// src/salesAssessment/SalesAssessmentLayout.js
import { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Dashboard as DashboardIcon,
  Compare as CompareIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import SalesAssessmentConfiguration from './SalesAssessmentConfiguration';
import SalesAssessmentDashboardWrapper from './SalesAssessmentDashboardWrapper';
import SalesAssessmentComparison from './SalesAssessmentComparison';

const SalesAssessmentLayout = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* Header */}
      <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h4" component="h1" sx={{ mb: 1 }}>
          {t('salesAssessment.layout.title')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('salesAssessment.layout.subtitle')}
        </Typography>
      </Box>

      {/* Tabs Navigation */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="sales assessment tabs">
          <Tab
            icon={<AssignmentIcon />}
            iconPosition="start"
            label={t('salesAssessment.layout.createTab')}
            id="sales-assessment-tab-0"
            aria-controls="sales-assessment-tabpanel-0"
          />
          <Tab
            icon={<CompareIcon />}
            iconPosition="start"
            label={t('salesAssessment.layout.comparisonsTab')}
            id="sales-assessment-tab-1"
            aria-controls="sales-assessment-tabpanel-1"
          />
          <Tab
            icon={<DashboardIcon />}
            iconPosition="start"
            label={t('salesAssessment.layout.dashboardTab')}
            id="sales-assessment-tab-2"
            aria-controls="sales-assessment-tabpanel-2"
          />
        </Tabs>
      </Box>

      {/* Tab Panels */}
      <Box sx={{ p: 3 }}>
        {tabValue === 0 && <SalesAssessmentConfiguration />}
        {tabValue === 1 && <SalesAssessmentComparison />}
        {tabValue === 2 && <SalesAssessmentDashboardWrapper />}
      </Box>
    </Box>
  );
};

export default SalesAssessmentLayout;